import React, { FunctionComponent } from 'react'
import classnames from 'classnames'

export type Callback<T = void> = (...args: any) => T

interface Header {
  direction?: string
  displayHeader: string
  sortEnum?: string
  sortable: boolean
}

interface Search {
  direction?: string
  sort?: string
}

interface Batch {
  batchCallback: Callback
  batchState: boolean
}

export interface Props {
  batch?: Batch
  clickCallback?: Callback
  headerList: Header[]
  parsedSearch: Search
}

export const IndexHeaderRow: FunctionComponent<Props> = ({
  headerList,
  parsedSearch,
  clickCallback,
  batch: { batchCallback, batchState } = {} as Partial<Batch>,
}) => {
  const updatedHeaders = headerList.map((header) => {
    if (header.sortEnum === parsedSearch.sort) {
      return {
        ...header,
        ...{ sort: parsedSearch.sort, direction: parsedSearch.direction },
      }
    } else {
      return header
    }
  })

  const headers = updatedHeaders.map((header) => {
    if (header.sortable) {
      return (
        <th
          className="index-table__cell index-table__cell-clickable"
          key={header.displayHeader}
          data-testid={`indexHeader-${header.sortEnum}`}
          onClick={() => {
            clickCallback && clickCallback(header.sortEnum)
          }}
        >
          {header.displayHeader}
          <span
            className={classnames(
              'index-table__arrows',
              {
                'index-table__arrow-down': header.direction === 'DESC',
              },
              {
                'index-table__arrow-up': header.direction === 'ASC',
              }
            )}
          />
        </th>
      )
    } else {
      return (
        <th className="index-table__cell" key={header.displayHeader}>
          {header.displayHeader}
        </th>
      )
    }
  })

  const batchHeaderCell = (batchState, batchCallback) => {
    if (!batchCallback) return null
    return (
      <th className="index-table__cell" key="batchActionCheckbox">
        <input
          type="checkbox"
          id="task-checkbox"
          className="index-table__checkbox"
          data-testid="indexTableBatchAction"
          checked={batchState}
          onChange={() => batchCallback()}
        />
      </th>
    )
  }

  if (batchCallback) {
    const headersWithBatch = [
      batchHeaderCell(batchState, batchCallback),
      ...headers,
    ]
    return (
      <thead>
        <tr className="index-table__row--head index-table__row--batch-header">
          {headersWithBatch}
        </tr>
      </thead>
    )
  } else {
    return (
      <thead>
        <tr className="index-table__row--head">{headers}</tr>
      </thead>
    )
  }
}

IndexHeaderRow.displayName = 'IndexHeaderRow'

export default IndexHeaderRow
